"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ColumnRole = {
  relatedConcepts: [],
  type: 'structure'
};
var _default = ColumnRole;
exports.default = _default;